module.exports = __webpack_public_path__ + "static/media/TMT 2b1.3ef98c88.jpg";